// Authentication Pages
import AdminLogin from "../pages/admin/auth/login";
import FrontLogin from "../pages/auth/Login";
import OtpVerification from "../pages/auth/OtpVerification";
import ResetPassword from "../pages/auth/ResetPassword";
import ForgotPassword from "../pages/auth/ForgotPassword";
import AdminForgotPassword from "../pages/admin/auth/ForgotPassword";
import AcceptUser from "../pages/admin/reset-password/ResetPassword";
import Login from "../pages/auth/Login";
import { userRoutes } from "../pages/admin/modules/users/user.routes";
import { dashboardRoutes } from "../pages/admin/modules/dashboard/dashboard.routes";
import { faqRoutes } from "../pages/admin/modules/Faqs/FaqList/faqs.routes";
import { faqCategoryRoutes } from "../pages/admin/modules/Faqs/FaqCategory/faqCategory.routes";
import { planRoutes } from "../pages/admin/modules/Plan/plan.routes";
import { formRoutes } from "../pages/admin/modules/Forms/forms.routes";
import { editorRoutes } from "../pages/admin/modules/Editor/editor.routes";
import { profileRoutes } from "../pages/admin/modules/profile/profile.routes";
import { taxRoutes } from "../pages/admin/modules/Tax/tax.routes";
import { activityRoutes } from "../pages/admin/modules/Activity/activity.routes";
import { emailTemplateRoutes } from "../pages/admin/modules/EmailTemplate/emailTemplate.routes";
import { siteSettingsRoutes } from "../pages/admin/modules/site-settings/siteSettings.routes";
import { enquiryRoutes } from "../pages/admin/modules/Enquiry/enquiry.routes";
import { pageRoutes } from "../pages/admin/modules/Page/page.routes";
import { discountRoutes } from "../pages/admin/modules/Discount/discount.route";
import { organizationRoutes } from "../pages/admin/modules/Organization/organization.routes";
import { paymentGetwayRoutes } from "../pages/admin/modules/PaymentGetway/paymentGetway.routes";
import { paymentRoutes } from "../pages/admin/modules/Payment/payment.routes";
import { testimonialRoutes } from "../pages/admin/modules/Testimonial/testimonial.routes";
import { howitworksRoutes } from "../pages/admin/modules/HowItWorks/howitworks.routes";
import { blogRoutes } from "../pages/admin/modules/Blogs/BlogsList/blogs.routes";
import { blogCategoryRoutes } from "../pages/admin/modules/Blogs/BlogCategory/blogCategory.routes";
import { blogCommentRoutes } from "../pages/admin/modules/Blogs/BlogComment/blogComment.routes";
import { blogTagsRoutes } from "../pages/admin/modules/Blogs/BlogTags/blogTags.routes";
import { serviceRoutes } from "../pages/admin/modules/Services/ServiceList/service.routes";
import { serviceCategoryRoutes } from "../pages/admin/modules/Services/ServiceCategory/serviceCategory.routes";
import { serviceTagsRoutes } from "../pages/admin/modules/Services/ServiceTags/serviceTags.routes";
import { mediaRoutes } from "../pages/admin/modules/Media/media.routes";
import { classifiedRoutes } from "../pages/admin/modules/Classifieds/ClassifiedList/classifieds.routes";
import { classifiedsCategoryRoutes } from "../pages/admin/modules/Classifieds/ClassifiedCategory/classifiedCategory.routes";
import { classifiedTagsRoutes } from "../pages/admin/modules/Classifieds/ClassifiedTags/classifiedTags.routes";
import { eventCategoryRoutes } from "../pages/admin/modules/Events/EventCategory/eventCategory.routes";
import { eventTagsRoutes } from "../pages/admin/modules/Events/EventTags/eventTags.routes";
import { productRoutes } from "../pages/admin/modules/Products/ProductList/product.routes";
import { productCategoryRoutes } from "../pages/admin/modules/Products/ProductCategory/productCategory.routes";
import { eventRoutes } from "../pages/admin/modules/Events/EventsList/events.routes";
import { jobCategoryRoutes } from "../pages/admin/modules/Jobs/JobCategory/jobCategory.routes";
import { jobTagsRoutes } from "../pages/admin/modules/Jobs/JobTags/jobTags.routes";
import { jobDepartmentRoutes } from "../pages/admin/modules/Jobs/JobDepartment/jobDepartment.routes";
import { jobsApplicationRoutes } from "../pages/admin/modules/Jobs/JobApplication/jobApplication.routes";
import { jobExperienceRoutes } from "../pages/admin/modules/Jobs/JobExperience/jobExperience.routes";
import { jobSalaryRangeRoutes } from "../pages/admin/modules/Jobs/JobSalaryRange/jobSalaryRange.routes";
import { jobSkillRoutes } from "../pages/admin/modules/Jobs/JobSkill/jobSkill.routes";
import { jobQualificationRoutes } from "../pages/admin/modules/Jobs/JobQualification/jobQualification.routes";
import { jobEnquiryRoutes } from "../pages/admin/modules/Jobs/JobEnquiry/jobEnquiry.routes";
import { newsletterRoutes } from "../pages/admin/modules/Enquiry/Newsletter/newsletter.routes";
import { roleRoutes } from "../pages/admin/modules/Role/role.routes";
// import { freelancerCategoryRoutes } from "../pages/admin/modules/Freelancers/FreelancerCategory/freelancerCategory.routes";
// import { freelancerTagsRoutes } from "../pages/admin/modules/Freelancers/FreelancerTags/freelancerTags.routes";
// import { freelanceBudgetRoutes } from "../pages/admin/modules/Freelancers/FreelanceBudget/freelanceBudget.routes";
// import { productTagsRoutes } from "../pages/admin/modules/Products/ProductTags/productTags.routes";
import { jobsRoutes } from "../pages/admin/modules/Jobs/JobList/jobs.routes";
// import { freelancerRoutes } from "../pages/admin/modules/Freelancers/FreelancerList/freelancer.routes";
// import { freelanceEnquiryRoutes } from "../pages/admin/modules/Freelancers/FreelanceEnquiry/freelanceEnquiry.routes";

import { homeRoutes, } from "../pages/home/home.routes";
import { jobsListRoutes } from "../pages/user/Jobs/JobsList/jobsList.routes";
import { jobApplyRoutes } from "../pages/user/Jobs/JobApply/jobApply.routes";

import { cryptoCurrencyRoutes } from "../pages/admin/modules/CryptoCurrency/CryptoCurrencyList/cryptoCurrency.routes";
import { userDashboardRoutes } from "../pages/user/dashboard/dashboard.routes";
import { aboutRoutes } from "../pages/about/about.routes";
import { testimonialsRoutes } from "../pages/testimonials/testimonials.routes";
import { blogsRoutes } from "../pages/blogs/blog.routes";
import { careerRoutes } from "../pages/career/career.routes";
import { buyRoutes } from "../pages/buy-sell/buy.Routes";
import { helpRoutes } from "../pages/helps/help.routes";
import { blogsDetailsRoutes } from "../pages/BlogDetails/blogDetails.routes";

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//     component: component || React.lazy(() => import("../pages/auth/Login")),
//     layout: "auth"||"front"||"admin",
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//         component: component || React.lazy(() => import("../pages/employees/Manage")),
//         layout: "auth"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

export const authRoutes = (data) => [
  {
    path: "/login",
    title: "login",
    component: Login,
  },
  {
    path: "/accept-user",
    title: "Accept User",
    component: AcceptUser,
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  {
    path: "/signin",
    title: "signin",
    component: FrontLogin,
    routeType: "auth",
  },
  {
    path: "/account-verification",
    title: "OTP Verification",
    component: OtpVerification,
    routeType: "auth",
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: "auth",
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];

export const routerData = (data) => {
  return [
    ...authRoutes(data),
    ...dashboardRoutes(data),
    ...userRoutes(data),
    ...mediaRoutes(data),
    ...blogRoutes(data),
    ...blogCategoryRoutes(data),
    ...blogTagsRoutes(data),
    ...blogCommentRoutes(data),
    ...classifiedRoutes(data),
    ...classifiedsCategoryRoutes(data),
    ...classifiedTagsRoutes(data),
    ...cryptoCurrencyRoutes(data),
    ...productRoutes(data),
    ...productCategoryRoutes(data),
    ...eventRoutes(data),
    // ...productTagsRoutes(data),
    ...jobsRoutes(data),
    ...jobsApplicationRoutes(data),
    ...jobCategoryRoutes(data),
    ...jobTagsRoutes(data),
    ...jobDepartmentRoutes(data),
    ...jobExperienceRoutes(data),
    ...jobSkillRoutes(data),
    ...jobSalaryRangeRoutes(data),
    ...jobQualificationRoutes(data),
    ...jobEnquiryRoutes(data),
    // ...freelancerRoutes(data),
    // ...freelancerCategoryRoutes(data),
    // ...freelancerTagsRoutes(data),
    // ...freelanceEnquiryRoutes(data),
    // ...freelanceBudgetRoutes(data),
    ...newsletterRoutes(data),
    ...roleRoutes(data),
    ...eventCategoryRoutes(data),
    ...eventTagsRoutes(data),
    ...serviceRoutes(data),
    ...serviceCategoryRoutes(data),
    ...serviceTagsRoutes(data),
    ...faqRoutes(data),
    ...faqCategoryRoutes(data),
    ...testimonialRoutes(data),
    ...howitworksRoutes(data),
    ...planRoutes(data),
    ...formRoutes(data),
    ...editorRoutes(data),
    ...profileRoutes(data),
    ...taxRoutes(data),
    ...activityRoutes(data),
    ...emailTemplateRoutes(data),
    ...siteSettingsRoutes(data),
    ...enquiryRoutes(data),
    ...pageRoutes(data),
    ...discountRoutes(data),
    ...organizationRoutes(data),
    ...paymentGetwayRoutes(data),
    ...paymentRoutes(data),
    ...userDashboardRoutes(data),
    ...jobsListRoutes(data),
    ...jobApplyRoutes(data),
    ...homeRoutes(data),
    ...aboutRoutes(data),
    ...testimonialsRoutes(data),
    ...blogsRoutes(data),
    ...careerRoutes(data),
    ...buyRoutes(data),
    ...helpRoutes(data),
    ...blogsDetailsRoutes(data)
  ];
};
